import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const ui = constants.colors.ui;
const footerBorderColorRGB = ui.neutral[100];

export const buttonContainerCss: CSSObject = {
  marginTop: "16px",
  display: "grid",
  gap: "20px",
  gridTemplateColumns: "1fr 1fr",
};

export const featureButtonCss: CSSObject = {
  padding: "8px",
  justifyContent: "center",
  width: "100%",
};

export const footerStyles: CSSObject = {
  borderTop: `1px solid ${footerBorderColorRGB}`,
  padding: "14px 20px",
  verticalAlign: "middle",
};

export const footerTextStyles: CSSObject = {
  color: ui.neutral[500],
  "&&&&": {
    margin: "0",
    lineHeight: "150%",
  },
};

export const disableFeatureToastTextCss: CSSObject = {
  "& div": {
    display: "inline-block",
  },
};

export const disableFeatureToastButtonCss: CSSObject = {
  textDecoration: "underline",
};
